// extracted by mini-css-extract-plugin
module.exports = {"flag":"CountryCodeSelect_flag__1JiJD"};